import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2 {...{
      "id": "exporting-events"
    }}>{`Exporting events`}</h2>
    <p>{`We will use the `}<a parentName="p" {...{
        "href": "https://github.com/PostHog/posthog-plugin-migrator3000"
      }}>{`PostHog Migrator 3000`}</a>{`.`}</p>
    <h3 {...{
      "id": "important-considerations"
    }}>{`Important considerations`}</h3>
    <p>{`This app works on PostHog instances with version 1.29.0 or above.`}</p>
    <p>{`Version 1.30.0 fixes a bug with exporting autocaptured events, so, unless you do not use autocapture at all, we recommend upgrading to 1.30.0 on both instances before performing the events migration.`}</p>
    <h3 {...{
      "id": "instructions"
    }}>{`Instructions`}</h3>
    <ol>
      <li parentName="ol">
        <p parentName="li">{`Get your Project API Key (token) for your new instance from the 'Project Settings' page. `}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Visit the 'Apps' page on the old instance and click on the 'Advanced' tab.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Under 'Install from GitHub, GitLab or npm', add the URL `}<inlineCode parentName="p">{`https://github.com/PostHog/posthog-plugin-migrator3000`}</inlineCode>{` and click 'Fetch and install'.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`A app configuration drawer should open. Here, add the hostname for your new instance, as well as the project API key from step 1. Also, make sure the toggle at the top is 'Enabled'.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Specify a date to start exporting events in the format `}<inlineCode parentName="p">{`YYYY-MM-DD`}</inlineCode>{` (e.g. 2021-10-26) and click 'Save'.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`That's it! The app will now start exporting your events to the new instance. To keep track of its progress, click on the 'Logs' icon for the app. Ignore the progress bar, focusing instead on the timestamps in the logs. Once the app is done exporting all of your historical events, it will then continue to export the events that are coming in live, but with a delay. Our recommendation is to change the event sources to point to the new instance once you notice all historical events have been exported.`}</p>
      </li>
    </ol>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      